import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ScrollToTop = props => {
  const location = useSelector(state => state.getIn(['router', 'location']));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return props.children;
};

export default ScrollToTop;
